window.paymentMethodOptions = {
    banks: {
        'au_becs_debit': 'BECS Direct Debit',
        'bacs_debit': 'Bacs Direct Debit',
        'bancontact': 'Bancontact',
        'blik': 'BLIK',
        'eps': 'EPS',
        'fpx': 'FPX',
        'giropay': 'giropay',
        'sepa_debit': 'SEPA Direct Debit',
        'sofort': 'Sofort',
        'us_bank_account': 'ACH Direct Debit',
        'p24': 'Przelewy24',
        'customer_balance': 'Bank transfers',
    },
    buy_now_pay_later: {
        'affirm': 'Affirm',
        'afterpay_clearpay': 'Afterpay / Clearpay',
        'zip': 'Zip',
        'klarna': 'Klarna',
    },
    real_time: {
        'paynow': 'PayNow',
        'promptpay': 'PromptPay',
        'pix': 'Pix',
    },
    cards: {
        'card': 'Card',
        'card_present': 'Card Machine',
        'interac_present': 'Card Machine',
    },
    vouchers: {
        'konbini': 'Konbini',
        'oxxo': 'OXXO',
        'boleto': 'Boleto',
    },
    wallets: {
        'cashapp': 'Cash App Pay',
        'grabpay': 'GrabPay',
        'link': 'Link',
        'paypal': 'PayPal',
        'wechat_pay': 'WeChat Pay',
    },

    allTypes(){
        return {
            ...this.banks,
            ...this.buy_now_pay_later,
            ...this.real_time,
            ...this.cards,
            ...this.vouchers,
            ...this.wallets,
        };
    },

    getName(type, brand = null){
        if (this.isCard(type)) {
            return brand;
        }

        return this.allTypes()[type];
    },

    getIcon(type, brand = null){
        if (this.isCard(type)) {
            return '/images/card-brand/' + (brand ?? 'default') + '.svg';
        }

        if (this.isBank(type)) {
            return '/images/payment-methods/bank.svg';
        }

        return '/images/payment-methods/' + type + '.svg';
    },

    isCard(type){
        return Object.keys(this.cards).includes(type);
    },

    isBank(type){
        return Object.keys(this.banks).includes(type);
    },
};
